import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { httpClient } from '@/api/http-client'

export type RcpQuoteAddressPayload = {
  zip_code: string
  street: string
  number: string
  complement?: string
  district: string
  city: string
  state_code: string
}

export type SubmitRcpQuotePayload = {
  tax_id: string
  full_name: string
  has_social_name: boolean
  social_name?: string
  phone_type: 'celular' | 'comercial' | 'residencial'
  phone: string
  insurance_kind: 'new' | 'renewal'
  previous_company_name?: string
  continuity_date?: string
  professional_categories: Array<
    'medicos' | 'odontologia' | 'demais_profissionais'
  >
  specialties: string[]
  had_claims_last_5_years: boolean
  knows_future_claim_risk: boolean
  has_active_professional_registration: boolean
  email: string
  marital_status: 'solteiro' | 'casado' | 'viuvo' | 'desquitado' | 'divorciado'
  sex: 'masculino' | 'feminino'
  is_politically_exposed: boolean
  lives_in_brazil: boolean
  coverages: number[]
  residential_address: RcpQuoteAddressPayload
  use_residential_as_billing: boolean
  billing_address?: RcpQuoteAddressPayload
}

type Params = {
  companyKey: string
  data: SubmitRcpQuotePayload
}

export async function submitRcpQuote({ companyKey, data }: Params) {
  const response = await httpClient('accounting-dealer').post(
    `/v3/insurance/${companyKey}/rcp-quote`,
    data,
  )

  return response.data
}

export function useSubmitRcpQuote(
  options?: UseMutationOptions<unknown, AxiosError, Params>,
) {
  return useMutation({
    mutationFn: submitRcpQuote,
    ...options,
  })
}
